import { z } from 'zod';

export const RiskConsequenceSchema = z.object({
    name: z.string().min(1, 'form.validation.nameRequired').max(500),
    description: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateRiskConsequenceSchema = RiskConsequenceSchema;

export const UpdateRiskConsequenceSchema = RiskConsequenceSchema.partial();
